<div class="chart-container">
  <h2 class="mdlz-chart-header">Capacity Waterfall (MM lbs)</h2>
  <div class="chart-wrapper">
    <div id="divChart">
      <canvas id="capacityWaterfall" height="300"></canvas>
    </div>
  </div>
</div>
